import { z } from 'zod'

export const schema = z.object({
  cottages: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
      description: z.string(),
      url: z.string(),
      media: z.object({
        url: z.string(),
      }),
      province: z.object({
        name: z.string(),
        slug: z.string(),
      }),
      reviews: z.object({
        total: z.number().int(),
        average: z.number(),
      }),
      averagePriceAmount: z.object({
        amount: z.number().int(),
        currency: z.string(),
      }),
    }),
  ),
})

export type schemaType = z.infer<typeof schema>

export type returnType = ApiServerResponse<schemaType>
